import { useEffect, useMemo, useRef, useState } from "react"
import FlexibleTable, { FlexibleTableRef } from "src/shared/components/data-display/FlexibleTable/FlexibleTable"
import { tableItems, tableItemsRecepcion } from "../../data/Gastos.constants"
import { AddButton } from "../AddButton/AddGasto"
import { Gastos } from "src/gql/schema"
import AddModalEdithGasto from "../EdithGAsto/EditGasto"
import AddModalCrearGasto from "../AddModalCrearGasto/AddModalCrearGasto"
import { useCurrentRol } from "src/shared/widgets/hooks/general"
import { useGastosList } from "./GastosList.hooks"
import { useProfile } from "src/shared/hooks/useProfile"
import DeleteModal from "../DeleteModal/DeleteModal"
import { PAYMENT_TYPES } from "src/constants/payments"
import { RootState } from "src/store/store"
import { useDispatch, useSelector } from "react-redux"
import { toggleNuevoGastoModalOpen } from "src/store/gastos/gastosSlice"
import useAuth, { RoleNames } from "src/shared/hooks/useAuth"
import AuthRequiredModal from "src/pages/inventario/modals/Auth/AuthRequiredModal/AuthRequiredModal"
import useIsColaboradorActive from "src/shared/hooks/useIsColaboradorActive"
import TablePaginatorWrapper from "src/shared/components/data-display/FlexibleTable/sections/TablePaginatorWrapper/TablePaginatorWrapper"
import GastosNotList from "../gastos-not-list/GastosNotList"
import { tableSkeletonRows } from "src/shared/components/layout/skeleton/TableSkeleton/TableSkeleton"
import { getRowsRecepcion } from "./helpers/RowsRecepcion"
import useGetCurrentDate from "src/shared/hooks/useGetCurrentDate"
import { getRowsAdmin } from "./helpers/RowsAdmin"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import useGetGastosList from "./hooks/useGetGastosList"
import useGastosCards from "./GastosCards/useGastosCards"
import { FlexibleTableHeaderColumn } from "src/shared/components/data-display/FlexibleTable/flexible-table-items.interface"

export const PAYMENT_METHODS = {
    efectivo: { label: "Efectivo", value: PAYMENT_TYPES.Efectivo },
    visa_o_mastercard: { label: "Visa o Mastercard", value: PAYMENT_TYPES.VisaOMastercard },
    amex: { label: "AMEX", value: PAYMENT_TYPES.amex },
    deposito_o_transferencia: { label: "Depósito/Transfer", value: PAYMENT_TYPES.DepositoOTransferencia },
}

interface GastosRow {
    value: {
        value: string
    }[]
}

interface Props {
    search: string
    categoryId: string
    categoryName: string
    date: string
    year: string
    reload: () => void
}

const GastosList = ({ search = "", date = "", year = "", reload, categoryId, categoryName }: Props) => {
    const rol = useCurrentRol()
    const [isModalEditGastoOpen, setisModalEditGastoOpen] = useState(false)
    const { InactiveModal, validateIsColabActive } = useIsColaboradorActive()

    const { isNuevoGastoModalOpen } = useSelector((state: RootState) => state.gastos)
    const dispatch = useDispatch()

    const [deleteModal, setDeleteModal] = useState(false)
    const [edit, setEdit] = useState(false)
    const [rowsGastos, setRowsGastos] = useState<GastosRow[]>([])

    const [subCategoryIds, setSubCategoryIds] = useState<string[]>([])

    const { usuario_id, rolName } = useProfile()
    const profile = rolName
    const [slectG, setSelectG] = useState<Gastos>()
    const [page, setPage] = useState(1)
    const [showGradient, setShowGradient] = useState(false)
    const { currentDate } = useGetCurrentDate()

    const { Cards, refetchGastosCategorias } = useGastosCards({ categoryId: categoryId, categoryName, date, year, disableDetails: currentDate.getMonth() !== parseInt(date) || currentDate.getFullYear() !== parseInt(year) })

    const onSelectEditRecepcion = validateIsColabActive((gastoData: any) => {
        skip ? setisModalEditGastoOpen(true) : setisAuthModalOpen(true)
        setSelectG(gastoData)
        setEdit(true)
    })
    const onSelectDeleteRecepcion = validateIsColabActive((gastoData: any) => {
        setSelectG(gastoData)
        setDeleteModal(true)
    })

    const onSelectEditAdmin = (gastoData: any) => {
        skip ? setisModalEditGastoOpen(true) : setisAuthModalOpen(true)
        setSelectG(gastoData)
        setEdit(true)
    }

    const onSelecDeleteAdmin = (gastoData: any) => {
        setSelectG(gastoData)
        setDeleteModal(true)
    }

    const apiSubCategoryId = subCategoryIds.length === 1 ? subCategoryIds[0] : ""
    const { gastos, isLoading, totalPages, refetch: refetchGastos } = useGetGastosList({ categoryId, date, page, subCategoryId: apiSubCategoryId, year, search })

    const handleRefresh = () => {
        refetchGastos()
        if ([RoleNames.admin, RoleNames.gerente, RoleNames.superadmin].includes(rol)) {
            refetchGastosCategorias()
        } else {
            reload()
        }
    }
    const { formatCustomDate } = useFormatDate()

    useEffect(() => {
        const filteredGastos = subCategoryIds.length > 1
            ? gastos.filter((g) => subCategoryIds.includes(g.subcategoria_id || ""))
            : gastos

        if (filteredGastos.length) {
            const array: GastosRow[] =
                profile === RoleNames.recepcionista
                    ? getRowsRecepcion(filteredGastos, usuario_id, onSelectEditRecepcion, onSelectDeleteRecepcion, formatCustomDate, categoryId)
                    : getRowsAdmin(filteredGastos, currentDate, onSelectEditAdmin, onSelecDeleteAdmin, formatCustomDate, categoryId)

            setRowsGastos(array)
        } else {
            setRowsGastos([])
        }
    }, [gastos, subCategoryIds])

    const { selectedSubCategorias } = useGastosList({ categoryId, date, year, with_deleted_subcategories: true })

    const headersAdmin = useMemo<FlexibleTableHeaderColumn[]>(() => {
        return [
            {
                value: "#",
            },
            ...(categoryId ? [] : [{
                value: "Categoría",
            }]),
            {
                value: "Subcategoría",
                isFilterUnique: false,
                filterSuggetions: true,
                filterMenu: selectedSubCategorias?.map(({ subcategoria = "", subcategoria_gasto_id = "" }) => {
                    return {
                        value: subcategoria_gasto_id,
                        valueToDisplay: subcategoria,
                    }
                }),
            },
            ...(profile === RoleNames.admin || profile === RoleNames.superadmin
                ? tableItems.headers
                : tableItemsRecepcion.headers),
        ]
    }, [selectedSubCategorias, categoryId])

    const onSelectedFilters = (params) => {
        const ids = params
            .filter(({ fromHeader }) => fromHeader === "Subcategoría")
            .map(({ filter }) => filter)
        setSubCategoryIds(ids)
    }

    const [isAuthModalOpen, setisAuthModalOpen] = useState(false)
    const { Modal, skip } = useAuth({
        authModal: (
            <AuthRequiredModal
                authorizedPins={[RoleNames.recepcionista, RoleNames.admin, RoleNames.superadmin]}
                isOpen={isAuthModalOpen}
                onAuthFilled={(value, sampleData) => {
                    setisModalEditGastoOpen(true)
                    setisAuthModalOpen(false)
                }}
                onClose={() => setisAuthModalOpen(false)}
            />
        ),
        authorizedRoles: [RoleNames.recepcionista, RoleNames.admin, RoleNames.superadmin],
        isOpen: isAuthModalOpen,
        onClose: () => setisAuthModalOpen(false),
    })

    const { skeletonRows } = tableSkeletonRows({ headers: headersAdmin })
    
    const tableRef = useRef<FlexibleTableRef>(null)
    
    useEffect(() => {
        if(tableRef.current) {
            tableRef.current.setFiltersFromOuterState([])
        }
        setSubCategoryIds([])
    }, [categoryId, search])

    if (!rowsGastos.length && !isLoading && !subCategoryIds.length && !search) {
        return <GastosNotList categoriaSelected={categoryId.length ? {id: categoryId, name: categoryName} : undefined} reload={reload} refetchGastos={refetchGastos} />
    }

    return (
        <section>
            {Cards}
            <TablePaginatorWrapper
                currentPage={page}
                onChange={(p) => setPage(p)}
                pages={totalPages}
            >
                <div className={`gastos-table${showGradient ? " show-gradient" : ""}`} style={{
                    height: rol === RoleNames.recepcionista ? "calc(100vh - 240px)" : "calc(100vh - 345px)"
                }}>
                    <FlexibleTable
                        ref={tableRef}
                        tableItems={{
                            ...{
                                headers: headersAdmin,
                                rows: isLoading ? skeletonRows : rowsGastos.map((value) => ({
                                    value: value.value,
                                })),
                            },
                        }}
                        onSelectedFilters={onSelectedFilters}
                        emptyState={{
                            titile: search ? "Sin resultados" : subCategoryIds.length ? "Sin registro" : "",
                            subTitle:
                                search !== ""
                                    ? `No hay resultados para **'${search}'**. Intenta de nuevo.`
                                    : subCategoryIds.length ? "No hay gastos registrados en **'Financieros'**. Intenta de nuevo." : "No hay resultados. Intenta de nuevo.",
                            headerIcon: "searchLg",
                        }}
                        onHasScrollChange={setShowGradient}
                    />
                </div>
            </TablePaginatorWrapper>
            <AddButton onAdd={validateIsColabActive(() => dispatch(toggleNuevoGastoModalOpen(true)))} />
            {edit && slectG && isModalEditGastoOpen && (
                <AddModalEdithGasto gasto={slectG} closeModal={() => setEdit(false)} onConfirm={handleRefresh} />
            )}
            {deleteModal && slectG ? (
                <DeleteModal gasto={slectG} onCloseModal={() => setDeleteModal(false)} onConfirm={handleRefresh} />
            ) : null}
            {!!isNuevoGastoModalOpen && (
                <AddModalCrearGasto
                    categoriaSelected={categoryId.length ? {id: categoryId, name: categoryName} : undefined}
                    onConfirm={handleRefresh}
                    closeModal={(value) => {
                        dispatch(toggleNuevoGastoModalOpen(value))
                    }}
                />
            )}
            {Modal}
            {InactiveModal}
        </section>
    )
}

export default GastosList
